<template>
  <!-- <HelloWorld /> -->
  <div>
    <v-container>
      <v-layout row>
        <v-flex xs12>
          <h3>So many participants!</h3>
        </v-flex>
      </v-layout>
      <ParticipantList/>
    </v-container>
  </div>
</template>

<script>

import ParticipantList from "../components/ParticipantList";

export default {
  components: {
    ParticipantList
  }
};
</script>
      